<section class="content-header">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-6">
                <h4>Sobre o Tuto Admin</h4>
            </div>
        </div>
    </div>
</section>

<section class="content">
  <div class="container-fluid" style="width: 80%;">
    <p-panel  header="Informações sobre o sistema">
      Objetivo: Administrar tabelas do Sistema de Arvore Genealogica <br />
      Versão do frontend: 0.0.4 <br />
      Versão do backend: 0.0.3-SNAPSHOT <br />
      Data da atualização: 02/10/2023 <br />
      Créditos:
    </p-panel>
  </div>
</section>
